import { useMutation } from 'react-query';
import { DocumentLinkSettingDto } from '../../../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const updateDocumentLinkManagement = (project: DocumentLinkSettingDto) =>
    getProductReservationApi()
        .documentLinkSetting.updateUpdate(project)
        .then((response) => response.data);

const useUpdateDocumentLinkManagement = () => {
    const useUpdateDocumentLinkManagementMutation = useMutation(updateDocumentLinkManagement);

    return useUpdateDocumentLinkManagementMutation;
};

export default useUpdateDocumentLinkManagement;
